import { render, staticRenderFns } from "./AuthorProfileDialog.vue?vue&type=template&id=6505b870&scoped=true"
import script from "./AuthorProfileDialog.vue?vue&type=script&lang=ts"
export * from "./AuthorProfileDialog.vue?vue&type=script&lang=ts"
import style0 from "./AuthorProfileDialog.vue?vue&type=style&index=0&id=6505b870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505b870",
  null
  
)

export default component.exports